// The URL saved for an image is the full-size delivery copy (up to 1800px). A
// card or thumbnail asks Cloudinary for a copy sized to where it is drawn, so
// the browser downloads a fraction of the bytes. The stored asset and public id
// are untouched -- only the URL in the page changes. Anything that is not a
// Cloudinary upload URL is returned as it came.

const UPLOAD_MARKER = "/upload/";
const TRANSFORMATION_SEGMENT = /^[a-z]{1,4}_[^/]*$/i;

export const cloudinaryImageUrl = (url, { width } = {}) => {
  if (typeof url !== "string" || !url) return url || "";
  const w = Math.round(Number(width));
  if (!Number.isFinite(w) || w <= 0) return url;

  let parsed;
  try {
    parsed = new URL(url);
  } catch (error) {
    return url;
  }
  if (!/(^|\.)cloudinary\.com$/i.test(parsed.hostname)) return url;

  const markerIndex = parsed.pathname.indexOf(UPLOAD_MARKER);
  if (markerIndex < 0) return url;

  const head = parsed.pathname.slice(0, markerIndex + UPLOAD_MARKER.length);
  const segments = parsed.pathname.slice(head.length).split("/");
  while (segments.length > 1 && TRANSFORMATION_SEGMENT.test(segments[0])) {
    segments.shift();
  }

  // c_limit never enlarges a photo that is already smaller than the width.
  parsed.pathname = `${head}f_auto,q_auto,c_limit,w_${w}/${segments.join("/")}`;
  return parsed.toString();
};

// Display widths are roughly twice the CSS size so high-density screens stay sharp.
export const IMAGE_WIDTH = { thumb: 240, card: 800, gallery: 1200 };
